import { useEffect } from 'react'
import { useQuery, useQueryClient, type QueryClient } from '@tanstack/react-query'
import { usersApi } from '@/api/users'
import type { WorkflowRunStatus } from '@/types'
import { useTenantKey } from './useTenantKey'

const WORKFLOW_RUN_ACTIVITY_KEY_SEGMENT = 'workflow-run-activity'

export function invalidateMyWorkflowRunActivity(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    predicate: query => query.queryKey.includes(WORKFLOW_RUN_ACTIVITY_KEY_SEGMENT),
  })
}

export function useMyWorkflowRunActivity(enabled: boolean) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('users', 'me', WORKFLOW_RUN_ACTIVITY_KEY_SEGMENT),
    queryFn: usersApi.meWorkflowRunActivity,
    enabled,
  })
}

export function useRefreshMyWorkflowRunActivityOnStatusChange(runStatus: WorkflowRunStatus | undefined) {
  const queryClient = useQueryClient()
  useEffect(() => {
    if (runStatus) invalidateMyWorkflowRunActivity(queryClient)
  }, [runStatus, queryClient])
}
